import React from "react";
import "../../assets/css/vendor.bundle.css";
import "../../assets/css/style.css";
import "../../assets/css/theme.css";
import TrendingViewChart from "../tradingview_chart/TradingViewChart";
import MediumWidget from "../medium_widget/MediumWidget";
import ForexCrossRatesWidget from "../forexcrossrates_widget/ForexCrossRatesWidget";
import Navbar from "../common/NavBar";
import Footer from "../common/Footer";
import { Helmet } from "react-helmet-async";

const Bonds = () => {
  return (
    <div>
      <Helmet>
        <title>Bonds</title>
      </Helmet>
      <div className="site-header header-s1 is-sticky">
        <Navbar />
        {/* Banner/Slider */}
        <div className="page-head section row-vm light has-bg-image">
          <div className="imagebg bg-image-loaded" style={{ backgroundImage: `url(${require('../../assets/images/page-inside-bg.jpg')})` }}>
            <img
              src={require("../../assets/images/page-inside-bg.jpg")}
              alt="page-head"
            />
          </div>
          <div className="container">
            <div className="row text-center">
              <div className="col-md-12">
                <h2>Bonds</h2>
                <div className="page-breadcrumb">
                  <ul className="breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li className="active">
                      <span>Bonds</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* #end Banner/Slider */}
      </div>
      {/*Section */}
      <div className="section section-pad bg-grey">
        <div className="container">
          <h2>
            What is bond trading, and how does it work?
          </h2>
          <div class="gaps size-3x"></div>
          <div className="row row-vm forex-p">
            <div className="col-md-6">
              <div className="text-block text-left">
                <p>
                  A bond is an over-the-counter exchange-traded fund (ETF) and fixed-income investment vehicle
                  authorised by governments and corporations (IOU) as debt securities (Coupon and Zero-coupon bonds) for
                  a specific time period, primarily to start paying down other debts and help finance operational
                  processes through secondary market brokerage firms.
                  <br />
                  <br />
                  Bond trading refers to the ability of bond investors and traders (lenders) to purchase and sell
                  corporate and government bonds (bond issuers) in the bond market (public debt market).
                  On the bondholders' maturity date, the issuer (borrower) must repay the bond price (face value),
                  interest rate, and a fixed or variable interest payment (dividend) to the bondholders.
                  Bond investing is among the most efficient financial diversification strategies, according to traders.
                </p>
              </div>

              {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
            </div>
            <div className="col-md-6">
              <div className="text-block text-left">
                <h4>Bond markets:</h4>
                <ul className="checkbox-list">
                  <li>Bonds from emerging markets</li>
                  <li>Bonds backed by mortgages (MBS)</li>
                  <li>Bonds issued by municipalities (Munis)</li>
                  <li>Bonds of the government</li>
                  <li>Bonds issued by corporations (sometimes known as high yield bonds or junk bonds)</li>
                  <li>Bond Indices (Investment grade bonds, Guaranteed bonds, Secured bonds)</li>
                </ul>


              </div>

              {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
            </div>
          </div>
        </div>
      </div>
      {/*Section */}

      {/*Section */}
      <div className="section section-pad">
        <div className="container">
          <h2>
            What is the procedure for trading bonds?
          </h2>
          <div class="gaps size-3x"></div>
          <div className="row row-vm forex-p">
            <div className="col-md-6">
              <div className="text-block text-left">
                <p>
                  Treasury and agency bonds are fixed-income securities established by governments and corporations for
                  a specific length of time and sold to investors who could buy bonds as debt obligations and profit from bond
                  price and market volatility, coupon payments (dividends), and yield to maturity.
                  <br />
                  <ul className="checkbox-list">
                    <li>Bonds with a short maturity date (1-5 yrs)</li>
                    <li>Bonds with a medium-term maturity (5-12 yrs)</li>
                    <li>Bonds with a long maturity (12-30 yrs)</li>

                  </ul>
                </p>
              </div>

              {/* <div className="trendingview-chart res-m-bttm">
                                <TrendingViewChart />
                            </div> */}
            </div>
            <div className="col-md-6">
              <div className="text-block text-left">
                <p>
                  Bond trading is primarily influenced by stock market conditions and liquidity, interest rate risk, new bond
                  issuing, and the credit quality, risk, and rating of bond issuers. Bond funds are much more unpredictable because
                  their price and interest rate are not fixed. The bond's price is inversely proportional to interest rates
                  <br />
                  <ul className="checkbox-list">
                    <li>Bond yields are high, while bond prices are low.</li>
                    <li>Bond yields are low, but bond prices are high.</li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
          <p>The interest rate on a bond is determined at the time of purchase, and the bond issuer should pay it on a
            regular basis until the bond matures,
            at which point the bond investors must receive their initial investment back.
          </p>
        </div>
      </div>
      {/*Section */}
      {/*Section */}
      <div className="section section-pad bg-grey">
        <div className="container">
          <h2>Why Should You Trade Bond CFDs?</h2>
          <div class="text-left">
            <p>
              Since bonds provide a predictable income flow - bond coupon - as fixed-income assets, bond markets have lower volatility
              than stock and other markets. Bonds with lower coupon rates, on the other hand, are more unpredictable than those with
              higher coupon rates.
              <br />
              <br />
              Considering the low instability of bond trading, each individual bond's known features, and fixed coupon payments, many
              investors use bonds as an efficient financial diversification method, benefitting from the bond markets' lower fluctuations,
              liquidity, and risks. Until optimal portfolio diversification is achieved, investors frequently hold bond CFDs to maturity
              in order to secure their funds and profit potential, as the original amount invested in bonds trading will be repaid by the
              bond issuer.
              <br />
              <br />
              Regardless of the sort of investment, there are always hazards while trading. When governments and firms start issuing
              bonds or risk default, bond prices could be impacted negatively. Bonds trading could also be used to pick up bond yields
              by trading volatility (spread betting technique) or to take advantage of any prospective bond price gain due to a credit
              upgrade. Bond CFDs allow traders to resell bonds as interest rates rise rather than holding them until their maturity date.
            </p>
          </div>
        </div>
      </div>
      {/* End Section */}
      {/*Section */}
      <div className="section section-pad">
        <div className="container">
          <h2>
            A Prime Example
          </h2>
          <div class="gaps size-3x"></div>
          <div className="row row-vm forex-p " style={{ fontWeight: 'normal' }}>
            <div className="col-md-6">
              <div className="text-block text-left">
                <p>
                  Let's say you wish to trade CFDs on the US10YR, often known as the "US 10yr T-Note." Assume the US10YR is trading at
                  BID 130.62 and ASK 131.76.
                  <br />
                  <br />
                  You decide to purchase 100 US10YR contracts because you believe the price of the US10YR will increase in the future.
                  Your profit margin rate is 1%. This means you'll need to fund your margin account with 1% of the overall position value.
                </p>
              </div>

            </div>
            <div className="col-md-6">
              <div className="text-block text-center">
                <p>
                  1% x (100 x 131.76) = 131.76 USD
                  <br />
                  If the bond price increases to 132.3/133.2 within the next hour, you have a profitable trade. Sell at the present (bid)
                  value of US10YR, which is 132.3, to terminate your position.
                  <br />
                  <br />
                  ( 100 x (132.3 - 131.76) = 54 USD
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
      {/*Section */}
      <Footer />
    </div>
  );
};

export default Bonds;
